export var TextTypography;
(function (TextTypography) {
    TextTypography["largeTitle"] = "largeTitle";
    TextTypography["smallTitle"] = "smallTitle";
    TextTypography["listText"] = "listText";
    TextTypography["runningText"] = "runningText";
})(TextTypography || (TextTypography = {}));
export var TextPriority;
(function (TextPriority) {
    TextPriority["primary"] = "primary";
    TextPriority["secondary"] = "secondary";
})(TextPriority || (TextPriority = {}));
//# sourceMappingURL=types.js.map